import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { CommonUtil } from '../../../core/Utils/common-util';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-custom-library-announcement-modal',
  templateUrl: './custom-library-announcement-modal.component.html',
  styleUrls: ['./custom-library-announcement-modal.component.css']
})
export class CustomLibraryAnnouncementModalComponent implements OnInit {

  // subscriptions
  private _facilityOnChange: Subscription;
  private _currentFacility: FacilityObject;

  currentFacility: FacilityObject;
  popupData: any = {};

  constructor
    (private rootScopeService: RootScopeService,
      private _facilityService: FacilityService,
      public commonUtil: CommonUtil,
      private router: Router
    ) { }
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;

  @Output() onClose: EventEmitter<any> = new EventEmitter();
  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this._currentFacility = this._facilityService.selectedFacility();
    this.popupData = this._facilityService.getAnnouncements() || {};
    this.getRootScopeData();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;

    });
  }

  onButtonClick(goToScreen: string) {
    if (goToScreen === 'uploadVideo') {
      this.router.navigate(['/videoLibrary']);
      this.onClose.emit({isNavigated: true});
    } else {      
      this.onClose.emit();
    }
    this.rootScopeData.popupData.showCustomLibraryPopup  = false;
  }

}
